import { Action } from "redux";
import { put } from "redux-saga/effects";
import { push } from "react-router-redux";

import { INavigateAction } from "..";

export function* navigateToSaga(action: INavigateAction) {
  if (action.payload instanceof Error) {
    return;
  }

  yield put(push(action.payload.path));
}

export const navigationActions = (action: Action) =>
  /^@navigation\//.test(action.type);
